import { render, staticRenderFns } from "./single_sentence_writing.vue?vue&type=template&id=d8de7bec&scoped=true"
import script from "./single_sentence_writing.vue?vue&type=script&lang=js"
export * from "./single_sentence_writing.vue?vue&type=script&lang=js"
import style0 from "./single_sentence_writing.vue?vue&type=style&index=0&id=d8de7bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8de7bec",
  null
  
)

export default component.exports